export function watchVotes(parent) {
  if (parent != null) {
    return $(parent).on('click', '.vote_link', handleVoteClick);
  }
  return $('.vote_link').on('click', handleVoteClick);
}

function handleVoteClick(e) {
  e.preventDefault();
  const $this = $(this);
  $this
    .parent()
    .toggleClass('voted')
    .find('i')
    .toggleClass('upvote downvote');
  changeVoteCount($this);
  $.ajax({
    url: this.href,
    success(data) {
      $this.attr('href', data.href);
      return $this.find('i').html(data.count);
    },
    error() {
      return reverseVote($this);
    },
  });
  return false;
}

function changeVoteCount($this) {
  const $parent = $this.parent();
  let count = $this.find('i').text();
  if (!/^[\d]+$/.test(count)) {
    return false;
  } // test to see if it's an integer
  count = parseInt(count);
  count = $parent.hasClass('voted') ? count + 1 : count - 1;
  return $this.find('i').text(count);
}

function reverseVote($this) {
  $this
    .parent()
    .toggleClass('voted')
    .find('i')
    .toggleClass('upvote downvote');
  return changeVoteCount($this);
}
